import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaGlobe } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="apple-footer">
      <Container>
        {/* Footnote Disclaimers */}
        <div className="footer-disclaimers">
          <p>
            1. <strong>Peace i18 PRO (5G)</strong>, <strong>Peace NOVA 18 PRO</strong>, and <strong>Peace SC26</strong> are backed by our official 1-Year Peace Warranty. Battery life claims are based on internal testing standards and may vary depending on usage patterns and network conditions.
          </p>
          <p>
            2. Peace SC26 includes an integrated high-precision stylus pen built into the phone body. 5G connectivity on Peace i18 PRO requires a compatible carrier network and SIM plan.
          </p>
          <p>
            3. Visit our official website at <a href="https://www.peacemobiles.com" target="_blank" rel="noopener noreferrer" className="footer-link-highlight">www.peacemobiles.com</a> for authorized service centers.
          </p>
        </div>

        <hr className="footer-divider" />

        {/* Footer Navigation Columns */}
        <Row className="footer-links-grid py-4">
          <Col lg={3} md={6} sm={6} className="mb-4">
            <h5 className="footer-column-title">2026 Mobile Lineup</h5>
            <ul className="footer-links-list">
              <li><Link to="/products">Peace i18 PRO (5G Flagship)</Link></li>
              <li><Link to="/products">Peace NOVA 18 PRO</Link></li>
              <li><Link to="/products">Peace SC26 (Built-in Stylus)</Link></li>
              <li><Link to="/products">All Smartphone Models</Link></li>
              <li><a href="https://www.peacemobiles.com" target="_blank" rel="noopener noreferrer">Official Portal: www.peacemobiles.com</a></li>
            </ul>
          </Col>

          <Col lg={3} md={6} sm={6} className="mb-4">
            <h5 className="footer-column-title">Peace Experience</h5>
            <ul className="footer-links-list">
              <li><Link to="/about">About PeaceMobiles</Link></li>
              <li><Link to="/service-centre">Find a Service Centre</Link></li>
              <li><Link to="/about">Sustainability & Eco</Link></li>
              <li><Link to="/about">Careers</Link></li>
              <li><Link to="/admin/login">Dealer Portal</Link></li>
            </ul>
          </Col>

          <Col lg={3} md={6} sm={6} className="mb-4">
            <h5 className="footer-column-title">Customer Support</h5>
            <ul className="footer-links-list">
              <li><Link to="/support">Order Status & Tracking</Link></li>
              <li><Link to="/support">1-Year Warranty & PeaceCare</Link></li>
              <li><Link to="/faq">Frequently Asked Questions</Link></li>
              <li><Link to="/service-centre">Authorized Repairs</Link></li>
              <li><Link to="/contact">Contact Support Team</Link></li>
            </ul>
          </Col>

          <Col lg={3} md={6} sm={6} className="mb-4">
            <h5 className="footer-column-title">Connect with Peace</h5>
            <p className="footer-desc">
              Follow our official social channels at <strong>/peacemobile</strong> for announcements, updates, and releases.
            </p>
            <div className="footer-social-icons">
              <a 
                href="https://facebook.com/peacemobile" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon-btn" 
                aria-label="Facebook /peacemobile"
                title="Facebook: /peacemobile"
              >
                <FaFacebookF />
              </a>
              <a 
                href="https://twitter.com/peacemobile" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon-btn" 
                aria-label="Twitter /peacemobile"
                title="Twitter: /peacemobile"
              >
                <FaTwitter />
              </a>
              <a 
                href="https://instagram.com/peacemobile" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon-btn" 
                aria-label="Instagram /peacemobile"
                title="Instagram: /peacemobile"
              >
                <FaInstagram />
              </a>
              <a 
                href="https://youtube.com/peacemobile" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon-btn" 
                aria-label="YouTube /peacemobile"
                title="YouTube: /peacemobile"
              >
                <FaYoutube />
              </a>
            </div>
            <div className="footer-domain-badge mt-3">
              <a href="https://www.peacemobiles.com" target="_blank" rel="noopener noreferrer" className="domain-pill-link">
                <FaGlobe className="me-1" /> www.peacemobiles.com
              </a>
            </div>
          </Col>
        </Row>

        <hr className="footer-divider" />

        {/* Copyright & Legal Row */}
        <div className="footer-bottom-bar">
          <div className="footer-copyright">
            Copyright © {new Date().getFullYear()} <a href="https://www.peacemobiles.com" className="copyright-domain-link">PeaceMobiles (www.peacemobiles.com)</a>. All rights reserved.
          </div>
          <div className="footer-legal-links">
            <Link to="/faq">Privacy Policy</Link>
            <span className="bullet-sep">•</span>
            <Link to="/faq">Terms of Use</Link>
            <span className="bullet-sep">•</span>
            <Link to="/support">Sales & 1-Year Warranty Policy</Link>
            <span className="bullet-sep">•</span>
            <Link to="/contact">Site Map</Link>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
